module.exports = __webpack_public_path__ + "media/images/athletes/2426-6345f9b35cade219557bac3e166f923b.png";